import { FC } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { checkIsActive, KTIcon } from '../../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
  color?: boolean
  subTitle?: string
  userTypeBadge?: string
}

const MenuItem: FC<Props> = ({
  to,
  title,
  icon,
  fontIcon,
  hasArrow = false,
  hasBullet = false,
  color = false,
  subTitle = '',
  userTypeBadge = '',
}) => {
  const { pathname } = useLocation()

  return (
    <div className='menu-item me-lg-1'>
      <Link
        className={clsx('menu-link py-3', {
          'active menu-here': checkIsActive(pathname, to),
        })}
        to={to}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {icon && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}

        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}

        {/* <span className='menu-title' style={color ? {color: '#12B886'} : {}}>
          {title}
          <br />
          {subTitle}
        </span> */}


        <span className='menu-title' style={color ? { color: '#12B886' } : {}}>
          <div>{title}</div>
          {subTitle && <div>{subTitle}</div>}
          {userTypeBadge && (
            <div style={{ marginTop: '4px', marginLeft: '8px' }}>
              {/* <span className='badge badge-light-success fw-bold'>{userTypeBadge}</span> */}
              <span className="inline-flex items-center rounded-full bg-[#F4B7B9]/30 px-3 py-1 text-sm font-bold text-[#A85F62] ring-1 ring-[#F4B7B9]">
                {userTypeBadge}
              </span>
            </div>
          )}
        </span>
        {hasArrow && <span className='menu-arrow'></span>}
      </Link>
    </div>
  )
}

export { MenuItem }
